import * as Constant from './Constant';
export var validationType = function (type, value) {
    var isValid = true;
    switch (type) {
        case Constant.VALIDATION_TYPE_EMAIL:
            if (!value || !/\S+@\S+\.\S+/.test(value)) {
                isValid = false;
            }
            break;
        case Constant.VALIDATION_TYPE_ARRAY:
            if (!value || !value.length) {
                isValid = false;
            }
            break;
        default:
            if (!value) {
                isValid = false;
            }
            break;
    }
    return isValid;
};
export var validationSpecialCharacter = function (source) {
    var regexString = new RegExp("[#%{}\\\\<>*?/$!'\":@+`|=]");
    if (source.match(regexString)) {
        return true;
    }
    return false;
};
export var validate = function (values) {
    var errors = {};
    if (values) {
        Object.keys(values).forEach(function (field) {
            var data = values[field];
            if (data) {
                var type = data.type, value = data.value, name_1 = data.name;
                if (type === Constant.VALIDATION_TYPE_TEXT_NOT_SPECIAL_CHARACTER) {
                    if (!value) {
                        errors[field] = name_1 + " is required";
                    }
                    else {
                        if (validationSpecialCharacter(value)) {
                            var character = "#%{}\\<>*?/$!'";
                            var stringError = '' + name_1 + ' cannot contain special character: ' + character + '":@+`|=';
                            errors[field] = stringError;
                        }
                        else {
                            delete (errors[field]);
                        }
                    }
                }
                else if (!value || (type != Constant.VALIDATION_TYPE_EMAIL && !validationType(type, value))) {
                    errors[field] = name_1 + " is required";
                }
                else if (!validationType(type, value)) {
                    errors[field] = name_1 + " is invalid";
                }
                else {
                    delete (errors[field]);
                }
            }
        });
    }
    return errors;
};
